export interface PaginatedItems<T> {
  items: T[];
  currentItems: number;
  totalElements: number;
  canLoadMore: boolean;
  loadMore: () => void;
}

export type PaginatedItemState<T> = {
  items: T[];
  totalElements: number;
  page: number;
  totalPages: number;
};

export type PageResponse<T> = {
  items: T[];
  totalElements: number;
  page: number;
  totalPages: number;
};

export enum PaginatedItemsActions {
  InitialLoad = 'INITIAL_LOAD',
  LoadMore = 'LOAD_MORE',
}
export type InitialLoadAction<T> = {
  type: PaginatedItemsActions.InitialLoad;
  payload: {
    items: T[];
    totalElements: number;
    page: number;
    totalPages: number;
  };
};
export type LoadMoreAction<T> = {
  type: PaginatedItemsActions.LoadMore;
  payload: {
    items: T[];
    totalElements: number;
    page: number;
    totalPages: number;
  };
};

export type PaginatedItemsAction<T> = InitialLoadAction<T> | LoadMoreAction<T>;
